import { mapState, mapMutations, mapActions } from "vuex";
import { PLAN_NO, PLAN_TYPE } from "@/contants/plan";
import trackEvent, { PRICING_MODEL_EVENT } from "@/utils/tracker";

export default () => {
  return {
    data() {
      return {
        billingInterval: PLAN_TYPE.MONTHLY
      };
    },
    async created() {
      this.setYearlyMode(this.$route.params.yearlyMode);
      if (this.isYearly) this.billingInterval = PLAN_TYPE.ANNUALLY;
      if (Object.keys(this.paymentInfo).length > 0) return;
      await this.fetchPaymentInfo();
    },
    computed: {
      ...mapState("account", {
        shopInfo: state => state.shopInfo
      }),
      ...mapState("downgrade", {
        choosedPlan: state => state.choosedPlan
      }),
      ...mapState("dashboard", {
        paymentInfo: state => state.paymentInfo,
        isYearly: state => state.isYearly,
        currentBillingInterval: state => state.paymentInfo.type
      }),
      isDisableBillingInterval() {
        return this.currentBillingInterval === PLAN_TYPE.ANNUALLY;
      },
      planDiscount() {
        return this.pricingByPlan(this.choosedPlan, PLAN_TYPE.ANNUALLY)?.planDiscount;
      },
      annuallyPricePerMonth() {
        return (this.monthlyPrice - this.monthlyPrice * (this.planDiscount / 100)).toFixed(2) || "";
      },
      annuallyPrice() {
        return this.pricingByPlan(this.choosedPlan, PLAN_TYPE.ANNUALLY)?.price || "";
      },
      monthlyPrice() {
        return this.pricingByPlan(this.choosedPlan, PLAN_TYPE.MONTHLY)?.price || "";
      },
      billingIntervals() {
        return [
          {
            value: PLAN_TYPE.MONTHLY,
            text: this.$t("downgrade.confirm.billingInterval.monthly", { price: `$${this.monthlyPrice}` })
          },
          {
            value: PLAN_TYPE.ANNUALLY,
            text: this.$t("downgrade.confirm.billingInterval.yearly", { price: `$${this.checkNumberFormat(this.annuallyPrice / 12)}`, promotion: this.planDiscount })
          }
        ];
      },
      essentialsFeatures() {
        const SAVE_AND_EXPORT_TEMPLATE_LIMIT = 300;
        let features = [
          // this.$tc('downgrade.confirm.losedFeature.buid.monthlyTemplate'),
          this.$t("downgrade.confirm.losedFeature.buid.saveAndExport", {
            limit: this.isEnterpriseToBuild || this.isEnterpriseToOptimize ? this.$tc("dataNewPlan.plan.title.unlimited") : SAVE_AND_EXPORT_TEMPLATE_LIMIT
          }),
          this.$tc("downgrade.confirm.losedFeature.buid.popupElement"),
          this.$tc("downgrade.confirm.losedFeature.buid.contentScheduling")
        ];
        if (this.isEnterpriseToOptimize) {
          features = [features[1], features[2]];
        }
        return features;
      },
      advancesFeatures() {
        const CAMPAIGN_LIMIT = 20;
        let features = [
          this.$t("downgrade.confirm.losedFeature.optimize.campaign", {
            limit: this.isEnterpriseToBuild || this.isEnterpriseToOptimize ? this.$tc("dataNewPlan.plan.title.unlimited") : CAMPAIGN_LIMIT
          })
        ];
        const isDowngradeToBuildPlan = this.isEnterpriseToBuild || this.isOptimizeToBuild || this.isAdvancedToBuild;
        if (isDowngradeToBuildPlan) {
          features = features.concat(this.$t("downgrade.reviewPlan.versionRecordsPerPage", { amount: 100 }));
        }
        features = features.concat(this.$tc("downgrade.confirm.losedFeature.optimize.designSuggest"));
        if (this.isEnterpriseToOptimize) features.pop();
        return features;
      },
      supportFeatures() {
        let features = [this.$tc("downgrade.confirm.losedFeature.support.videoCall"), this.$tc("downgrade.confirm.losedFeature.support.priority")];
        if (this.isAdvancedToBuild) features.shift();
        return features;
      },
      losedEssentialsFeatures() {
        return {
          key: this.$tc("dataNewPlan.plan.tiltle.essentials").toUpperCase(),
          features: [...this.essentialsFeatures]
        };
      },

      losedAdvancesFeatures() {
        return {
          key: this.$tc("dataNewPlan.plan.advances").toUpperCase(),
          features: [...this.advancesFeatures]
        };
      },
      losedSupportFeatures() {
        return {
          key: this.$tc("upperCase.support"),
          features: [...this.supportFeatures]
        };
      },
      planPrice() {
        if (this.isYearly) {
          return `$${this.annuallyPrice}`;
        }
        return `$${this.monthlyPrice}`;
      },
      choosedPlanText() {
        switch (this.choosedPlan) {
          case PLAN_NO.OPTIMIZE:
            return this.$t("downgrade.confirm.choosedPlan", { plan: this.$t("dataNewPlan.plan.optimize") });
          default:
            return this.$t("downgrade.confirm.choosedPlan", { plan: this.$t("dataNewPlan.plan.build") });
        }
      }
    },
    methods: {
      ...mapMutations("dashboard", {
        setBillingType: "SET_YEARLY"
      }),
      ...mapActions("dashboard", {
        fetchPaymentInfo: "fetchPaymentInfo"
      }),
      setBillingInterval() {
        this.setYearlyMode(this.billingInterval == PLAN_TYPE.ANNUALLY);
      },
      pricingByPlan(planName, planType) {
        if (Object.keys(this.paymentInfo).length <= 0) return;
        return this.paymentInfo.plans.find(plan => plan.planType === planType && plan.planName === planName);
      },
      setYearlyMode(value) {
        this.setBillingType(value);
        try {
          trackEvent({
            eventId: PRICING_MODEL_EVENT.TOGGLE_PLAN_TYPE,
            properties: {
              type: value ? "yearly" : "monthly"
            }
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      },
      checkNumberFormat(num) {
        if (Number.isInteger(num)) {
          return num.toString();
        } else {
          return num.toFixed(2).toString();
        }
      }
    }
  };
};
